export async function clearAllCaches() {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map((cacheName) => caches.delete(cacheName))
    );
  }
}

export async function getCacheNames() {
  if ('caches' in window) return await caches.keys();
  return [];
}

export async function getCacheSize(cacheName) {
  if ('caches' in window) {
    const cache = await caches.open(cacheName);
    const keys = await cache.keys();
    let size = 0;
    for (const request of keys) {
      const response = await cache.match(request);
      if (response) {
        const blob = await response.blob();
        size += blob.size;
      }
    }
    return size;
  }
  return 0;
}

export async function getTotalCacheSize() {
  const cacheNames = await getCacheNames();
  let totalSize = 0;
  for (const cacheName of cacheNames) {
    totalSize += await getCacheSize(cacheName);
  }
  return totalSize;
}

export async function updateServiceWorker() {
  if ('serviceWorker' in navigator) {
    // `ready` nunca se resuelve si no hay service worker registrado (por ejemplo en desarrollo).
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return false;
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      return true;
    }
    const result = await registration.update();
    return result;
  }
  return false;
}

export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return false;
    const unregistered = await registration.unregister();
    if (unregistered) {
      await clearAllCaches();
    }
    return unregistered;
  }
  return false;
}